/**
 * Papéis do usuário, como o login os devolve em `session.roles`.
 *
 * O backend tem o enum `EUserRole`, e o Kubb o gera — mas **só como união de
 * números** (`1 | 2 | … | 26`), porque é assim que ele aparece no spec. Os nomes
 * vivem apenas na descrição em prosa da operação
 * `GET /api/v1/accesscontrol/roles`, e é o **nome** que o login manda no array
 * `roles`. Daí este enum de string: ele é a contrapartida nomeada do gerado, na
 * ordem dos ids, e existe para as comparações de papel não dependerem de string
 * solta espalhada pelas features.
 *
 * Manter em sincronia com a descrição de `EUserRole` em
 * `src/shared/api/generated/types/EUserRole.ts` — o valor de cada membro é o
 * nome exato que o backend envia, e um typo aqui só apareceria em runtime, como
 * uma ação que nunca some.
 */
export enum ERole {
  Master = 'Master',
  Administrator = 'Administrator',
  Polo = 'Polo',
  Basic = 'Basic',
  Relationship = 'Relationship',
  Planning = 'Planning',
  Secretary = 'Secretary',
  Communication = 'Communication',
  Financial = 'Financial',
  Visitor = 'Visitor',
  Api = 'API',
  StudentCare = 'StudentCare',
  Valoriza = 'Valoriza',
  Leads = 'Leads',
  Faculty = 'Faculty',
  Orientation = 'Orientation',
  Exams = 'Exams',
  BusinessCore = 'BusinessCore',
  Contracts = 'Contracts',
  HumanResources = 'HumanResources',
  Audiovisual = 'Audiovisual',
  ScholarshipTeam = 'ScholarshipTeam',
  Translation = 'Translation',
  Transmission = 'Transmission',
  RelationshipTR = 'RelationshipTR',
  International = 'International',
}
